<template>
  <v-card class="elevation-12 contact-us-form p-0 free-trail-card" fill-height>
    <v-card-text>
      <v-form ref="form" @submit.prevent="submitForm">
        <v-row>
          <v-col cols="12" md="6" class="py-1">
            <p>First Name:</p>
            <v-text-field
              v-model="first_name"
              :rules="[rules.required, rules.name]"
              label="First Name:"
              type="text"
              placeholder="John"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Last Name:</p>
            <v-text-field
              v-model="last_name"
              :rules="[rules.required, rules.name]"
              label="Last Name:"
              type="text"
              placeholder="Smith"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Company Name:</p>
            <v-text-field
              v-model="company_name"
              :rules="[rules.required]"
              label="Company Name"
              placeholder="Smith Inc"
              solo
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Email Address:</p>
            <v-text-field
              v-model="email"
              :rules="[rules.required, rules.email]"
              label="Email"
              placeholder="johnsmith@email.com"
              solo
              type="email"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Password:</p>
            <v-text-field
              v-model="password"
              :rules="[rules.required, rules.password]"
              label="Password"
              placeholder="*******"
              solo
              type="password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Confirm Password:</p>
            <v-text-field
              v-model="confirm_password"
              :rules="[rules.required]"
              label="Confirm Password"
              placeholder="*******"
              solo
              type="password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <div id="newsletter">
              <v-checkbox
                style="box-shadow: none !important;"
                v-model="newsletter"
                :label="
                  `I would like to receive the latest news and updates from IMPROVE`
                "
              ></v-checkbox>
            </div>
            <div class="text-center form-terms">
              By signing up to this free trial you are agreeing to our
              <a href="/eula">Terms and Conditions.</a> For details of how we
              use personal data please see our
              <a href="/privacy-policy">Privacy Policy</a>.
            </div>
            <div class="text-center pt-5">
              <v-btn
                :loading="loading"
                class="cyber-security-form-btn"
                type="submit"
              >
                Start your FREE trial
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import AuthAPI from '@/Api/auth.js';

export default {
  name: 'RegisterForm',
  data() {
    return {
      errorMessages: {},
      first_name: '',
      last_name: '',
      company_name: '',
      email: '',
      password: '',
      confirm_password: '',
      newsletter: false,
      refID: 'website',
      successMessage:
        'We have notified our team with your request. Someone from our team will be in touch shortly.',
      loading: false,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || 'Invalid email.';
        },
        name: (value) =>
          (value && value.length >= 2) || 'Name must be at least 2 characters.',
        password: function(value) {
          // Regular function declaration
          return (
            (value && value.length >= 6) ||
            'Password must be at least 6 characters.'
          );
        },
      },
    };
  },

  metaInfo() {
    return {
      title: 'Contact IMPROVE: #1 Online Learning Solution for SMEs',
      meta: [
        {
          name: 'description',
          content:
            "To start your FREE 14-day trial or to learn more about IMPROVE, the UK's first online learning platform for SMEs, get in touch with one of our experts today.",
        },
        {
          property: 'og:title',
          content: 'Contact IMPROVE: #1 Online Learning Solution for SMEs',
        },
        {
          property: 'og:description',
          content:
            "To start your FREE 14-day trial or to learn more about IMPROVE, the UK's first online learning platform for SMEs, get in touch with one of our experts today.",
        },
        {
          property: 'og:image',
          content:
            'https://www.improve.online/static/pages/contact/contact-bottom.png',
        },
      ],
    };
  },
  components: {
    // eslint-disable-next-line
    LayoutBasic, 
  },
  methods: {
    submitForm() {
      // check if password and confirm password are the same
      if (this.password !== this.confirm_password) {
        this.$snotify.error('Password and Confirm Password do not match');
        return;
      }

      if (this.$refs.form.validate()) {
        this.register();
      }
    },
    register() {
      this.loading = true;
      if (localStorage.getItem('refID') != '') {
        this.refID = localStorage.getItem('refID');
      }
      AuthAPI.register({
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        company_name: this.company_name,
        password: this.password,
        confirm_password: this.confirm_password,
        newsletter: this.newsletter,
        banding: 1,
        refid: this.refID,
      })
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.errorMessages = this.$gf.errorResponse(err);
        });
    },
  },
};
</script>
